import { FC } from 'react';
import { Card, Typography, Checkbox, Select } from 'antd';
import { TranslationOutlined } from '@ant-design/icons';
import styles from './consent-overlay.module.scss';
import dayjs from 'dayjs';
import { IConsentConfig } from '@datapeace/1up-frontend-shared-api';
import { useConsentLanguages } from '../../containers/useConsentLanguages';

const { Text, Paragraph } = Typography;

interface ConsentOverlayProps {
  consentConfig?: IConsentConfig | null;
  consentGiven: boolean;
  setConsentGiven: (given: boolean, consentProvidedAt?: string) => void;
}

export const ConsentOverlay: FC<ConsentOverlayProps> = ({
  consentConfig = null,
  consentGiven,
  setConsentGiven,
}) => {
  const { languages, activeLang, activeLangCode, setActiveLangCode } =
    useConsentLanguages(consentConfig);

  if (!activeLang) return null;

  const handleLangChange = (code: string) => {
    setActiveLangCode(code);
    setConsentGiven(false, undefined);
  };

  const handleConsentChange = (checked: boolean) => {
    setConsentGiven(checked, checked ? dayjs().toISOString() : undefined);
  };

  return (
    <div className={styles.ConsentOverlay}>
      <Card
        className={styles.ConsentContainer}
        bodyStyle={{ padding: 0 }}
        bordered={false}
        title={
          <div className={styles.ConsentHeader}>
            <Text strong>Consent Notice</Text>
            {languages.length > 1 && (
              <Select
                size="small"
                value={activeLangCode}
                onChange={handleLangChange}
                options={languages.map((l) => ({
                  label: l.label,
                  value: l.code,
                }))}
                style={{ minWidth: 130 }}
                suffixIcon={<TranslationOutlined />}
                dropdownMatchSelectWidth={false}
              />
            )}
          </div>
        }
      >
        <div className={styles.ConsentBody}>
          <Paragraph className={styles.ConsentText}>
            {activeLang.text}
          </Paragraph>
        </div>
      </Card>

      <div className={styles.ConsentCheckboxRow}>
        <Checkbox
          checked={consentGiven}
          onChange={(e) => handleConsentChange(e.target.checked)}
        >
          <Text className={styles.ConsentCheckboxLabel}>
            I agree to the above consent notice
          </Text>
        </Checkbox>
      </div>
    </div>
  );
};
